<template>
  <div class="form-item">
    <div
      v-show="label"
      class="label"
      :style="usWidth"
    >
      {{ label }}
    </div>
    <slot class="box" />
  </div>
</template>

<script>
export default {
  props: ['label'],
  computed: {
    usWidth() {
      if (window._language == 'en-us') {
        return 'width : 170px';
      } 
        return "width : ''";
      
    }
  }
};
</script>
<style lang="scss" scoped>
.form-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  // border-bottom: 1px solid #eee;
  .label {
    // width: 170px;
    margin-right: 15px;
  }
}
</style>
